<script>
	import { fade } from 'svelte/transition';
  import { onDestroy, onMount } from 'svelte'

  import Loader from './Loader.svelte'

  onMount(() => {
    document.body.style.overflowY = 'hidden'
  })

  onDestroy(() => {
    document.body.style.overflowY = 'visible'
  })
</script>

<div class="layout-loader" transition:fade>
  <div class="layout">
  </div>

  <div class="loader">
    <Loader color="#a8a8a8" size="50" />
  </div>
</div>

<style lang="scss">
  .layout-loader,
  .layout {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10000000000000;
  }

  .layout {
    background-color: black;
    opacity: .8;
  }

  .loader {
    position: absolute;
    z-index: 100000000000000;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
</style>